import localAxios from  '@/services/axiosPermisos'

import  {
  paths
} from './path'

async function getAbsenteeismTotalRecordedService ()
{
  return await localAxios.get(paths.totalRecorded, true, 'v2')
}

export {
  getAbsenteeismTotalRecordedService
}